import cx from "classnames";
import {
    FormControlLabel, FormGroup, Checkbox,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import DoneIcon from "@mui/icons-material/Done";
import "./CheckboxOptions.css";

const CheckboxOptions = (props) => {
    const {
        options, value, onChange, className, error,
        disabled,
    } = props;

    return (
        <FormControl error={!!error} className="w-full">
            <FormGroup className={cx("checkbox-options", className)}>
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={(
                            <>
                                <Checkbox
                                    disabled={disabled}
                                    checked={(value || []).includes(option.value)}
                                    onChange={(e) => (e.target.checked
                                        ? onChange([...value, option.value])
                                        : onChange(value.filter((item) => item !== option.value)))}
                                />
                                {(value || []).includes(option.value) && <DoneIcon className="checkbox-options__label__icon" />}
                            </>
                        )}
                        checked={value.includes(option.value)}
                        className="checkbox-options__label"
                        label={option.label}
                        labelPlacement="end"
                        disabled={disabled}
                    />
                ))}
            </FormGroup>
            {error ? <FormHelperText>{error}</FormHelperText> : null}
        </FormControl>
    );
};

export default CheckboxOptions;
